import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface LoadingStoreState {
  maxAddCompartment: number;
  addCompartmentCount: number;
  spacesAvailable: number;
}

export interface LoadingStore {
  store$: Observable<LoadingStoreState>;
  decreaseSpacesAvailable(): void;
  updateSpacesAvailable(spacesAvailable: number): void;
  resetAddCompartmentCount(addCompartmentCount: number): void;
}

export const LOADING_STORE = new InjectionToken<LoadingStore>('LOADING_STORE');
